import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  IconButton,
  Box,
  Checkbox,
  List,
  ListItem,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import LinearProgress from "@mui/material/LinearProgress";
import ChecklistIcon from "@mui/icons-material/Checklist";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import EditIcon from "@mui/icons-material/Edit";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import getCookie from "../../../hooks/getCookie";
import AddTaskIcon from "@mui/icons-material/AddTask";
import CheckIcon from "@mui/icons-material/Check";
import ReactDOM from "react-dom";

export default function ChecklistPadrao() {


  return (
    <>
      <Box sx={{ width: "100%", bgcolor: "transparent", border: "none" }}>
        <Card className="checklist-card">
          <CardContent className="checklist-card-content">
            <Box className="checklist-header">
              <Box className="checklist-title-section">
                <ChecklistIcon className="checklist-icon" />
                <Typography variant="h6" className="checklist-title">
                  Lista de Tarefas
                </Typography>
              </Box>
              <IconButton className="checklist-menu-button">
                <MoreVertIcon />
              </IconButton>
            </Box>
            <Box className="progress-section">
              <Typography className="progress-text">
                {`${Math.round(50)}%`}
              </Typography>
              <LinearProgress
                variant="determinate"
                value={50}
                className="progress-bar"
              />
            </Box>
            <Divider className="section-divider" />
            <List className="tasks-list">
              <Box className="task-container">
                <ListItem className="task-item">
                  <Box className="task-content">
                    <Box className="task-left-section">
                            <Checkbox
                              className="task-checkbox"
                            />
                      <Box className="checklist-title">
                        <Typography>
                          Texto da tarefa principal
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="task-actions">
                      <IconButton
                        className="task-menu-button"
                        title="Opções da tarefa"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </ListItem>
                <Box className="subtask-container">
                  <Box className="subtask-content">
                    <Checkbox
                      size="small"
                      className="subtask-checkbox"
                    />
                    <Typography className="subtask-text">
                      {"Sou a subtarefa 1"}
                    </Typography>
                    <IconButton className="subtask-menu-button">
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                  <Box className="subtask-content">
                    <Checkbox
                      checked={"subtask.completed"}
                      size="small"
                      className="subtask-checkbox"
                    />
                    <Typography className="subtask-text subtask-completed">
                      {"Sou a subtarefa 2"}
                    </Typography>
                    <IconButton className="subtask-save-button">
                    <CheckRoundedIcon />
                    </IconButton>
                    <IconButton className="subtask-menu-button">
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </List>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
